import { memo } from 'react';
import { classnames } from '@/libs/utils';
import { MediaPickerTabBarProps } from '@/Pages/BrandKit/types';

function MediaPickerTabBar({
  tabs,
  activeTabId,
  onTabChange,
  variant = 'underline'
}: MediaPickerTabBarProps): JSX.Element {
  if (variant === 'pill') {
    return (
      <div className="flex flex-1 rounded-lg border-b border-slate-100 bg-slate-100 p-0.5">
        {tabs.map(tab => (
          <button
            key={tab.id}
            type="button"
            data-testid={`tab-${tab.id}`}
            onClick={() => onTabChange(tab.id)}
            className={classnames(
              'flex-1 rounded-lg py-1.5 text-sm font-medium text-slate-900 transition-all',
              activeTabId === tab.id ? 'bg-white shadow-sm' : ''
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="border-b border-slate-200">
      <div className="flex">
        {tabs.map(tab => (
          <button
            key={tab.id}
            type="button"
            onClick={() => onTabChange(tab.id)}
            className={`flex-1 py-3 text-sm font-medium transition-colors ${
              activeTabId === tab.id
                ? 'border-b-2 border-slate-900 text-slate-900'
                : 'text-slate-500 hover:text-slate-700'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default memo(MediaPickerTabBar);
